import React, { useId } from 'react';
import PropTypes from 'prop-types';
import './FormSection.css';

/**
 * One numbered group of fields inside a form card.
 *
 * Sections are hairline-separated rows of a single card rather than separate
 * cards, so a long form still reads as one object instead of a stack of
 * unrelated panels. Pages wrap their sections in `.itcFormCard` (declared in
 * this component's stylesheet, since the two are meaningless apart).
 */
export default function FormSection({ index, title, description, children }) {
  const headingId = useId();

  return (
    <section className="itcFormSection" aria-labelledby={headingId}>
      <div className="itcFormSectionHead">
        <span className="itcFormSectionNum" aria-hidden="true">
          {index}
        </span>
        <h2 className="itcFormSectionTitle" id={headingId}>
          {title}
        </h2>
      </div>

      {description && <p className="itcFormSectionDesc">{description}</p>}

      <div className="itcFormSectionBody">{children}</div>
    </section>
  );
}

FormSection.propTypes = {
  index: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.node,
};
